import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Helmet from 'react-helmet';

import styled from 'styled-components'
import cssVar from '../styles/variables'
import config from 'react-global-configuration';
import { ScrollHint, ScrollHintIcon, ScrollHintText, HeroSectionText, HeroContentWrapper, FullSizeBackgroundVideo, SlimSection, Heading4, LinkText, FullAreaWrapper, PrimaryButton, SecondaryButton, Text, Link, withColor, Heading2, Heading3, BiggerText, H1, GridRow, FullWidthWrapper, Section, FullWidthSection, HeroSection, Heading1, MaxContentWidthContainer, MaxContentWidthWrapper } from '../components/marketing/MarketingStyles';

import GolfCourseMap from '../components/marketing/GolfCourseMap'
import GolfCourseBenefits from '../components/marketing/GolfCourseBenefitsSection'
import GolfCourseCooperation from '../components/marketing/GolfCourseCooperationSection'

import Logo from '../images/logo.png'
import FlyOverArrow from '../images/icons/arrow-flyover.png'
import DiscoverMoreArrow from '../images/icons/arrow-discover-more.svg'

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import { inject, observer, Observer } from 'mobx-react'

import { trackEvent } from "../utils/eventTracking"

@inject('modalStore', 'utilStore', 'translationStore')
@observer
class Home extends Component {

   constructor(props) {
     super(props)
     this.state = {
       pressIndex: 1
     }
   }

  componentDidMount() {
  }

  render() {

    const { golf_course_page } = this.props.utilStore.util

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    return (
      <FullWidthWrapper>

        {/* --- HERO SECTION --- */}
        
        <HeroSection>
          <FullSizeBackgroundVideo>
            <img src={`${config.get('CLOUDINARY_URL')}w_1920/h_1080/q_auto/${ golf_course_page && golf_course_page.hero_background } `}/>
            {/* <video loop="true" autoPlay="true" muted="true" playsInline="true">
              <source src="https://res.cloudinary.com/theloge/video/upload/q_auto/v1632225467/Hero-Section-Video-golfcourse.mp4" type="video/mp4" />
            </video> */}
          </FullSizeBackgroundVideo>
          <MaxContentWidthWrapper style={{height: '100%'}}>
            <MaxContentWidthContainer style={{height: '100%'}}>
              <GridRow
                desktop="1fr 1fr 1fr"
                tablet="1fr"
                phone="1fr"
                style={{height: '100%'}}
              >
                <HeroContentWrapper>
                <H1 color="#FFFFFF" dangerouslySetInnerHTML={{__html: text('marketing_gc_landingpage__hero_title').replace('\n', '<br>')}}></H1>
                  <HeroSectionText>
                    { text('marketing_gc_landingpage__hero_text') }
                  </HeroSectionText>
                  <GridRow
                    desktop="auto auto"
                    phone="1fr"
                    phoneRowGap
                  >
                    <div>
                      <PrimaryButton value={ text('marketing_gc_landingpage__hero_button_text') } onClick={ () => { this.cooperationSection.scrollIntoView() }} autoWidth />
                    </div>
                  </GridRow>
                </HeroContentWrapper>
              </GridRow>
            </MaxContentWidthContainer>
          </MaxContentWidthWrapper>
          <ScrollHint onClick={ () => this.startOfPage.scrollIntoView()}>
            <ScrollHintText>{ text('marketing_gc_landingpage__hero_more') }</ScrollHintText>
            <ScrollHintIcon src={ DiscoverMoreArrow } />
          </ScrollHint>
        </HeroSection>

        <div ref={ (ref) => this.startOfPage=ref }></div>

        {/* --- INTRODUCTION SECTION --- */}
        
        <Section id="about">
          <GridRow
            desktop="1fr 1fr"
            tablet="1fr"
          >
            <div>
              <Heading1>{ text('marketing_gc_landingpage__introduction_title') }</Heading1>
              <BiggerText>{ text('marketing_gc_landingpage__introduction_text') }</BiggerText>
            </div>
          </GridRow>
        </Section>

        {/* --- BENFITS SECTION --- */}

        <GolfCourseBenefits />


        {/* --- COOPERATION SECTION --- */}

        <div ref={ (ref) => this.cooperationSection=ref }></div>
        <GolfCourseCooperation />

        {/* --- MAP SECTION --- */}

        <GolfCourseMapWrapper>
          <GolfCourseMap showPanel />
        </GolfCourseMapWrapper>

      </FullWidthWrapper>
    )
  }
}

export default withRouter(Home)

const GreyText = withColor(Text, cssVar.colors.grey)
const GreyLink = withColor(Link, cssVar.colors.grey)

const GolfCourseMapWrapper = styled(FullWidthSection) `
  height: 800px;

  ${cssVar.breakpoints.tablet} {
    height: auto;
  }
`



// WEBPACK FOOTER //
// /src/pages/GolfCourseLandingPage.js